import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  FilterOptions,
  PatchingDetailsResponse,
  PatchingHistoryResponse,
  PatchingSummaryResponse,
} from '../models/patch-management.models';
import { PatchQueryFilters } from '../components/patch-management/patch-management-filters.utils';

@Injectable({
  providedIn: 'root',
})
export class PatchManagementService {
  private readonly baseUrl = `${environment.restUrl}/v1/msp/patching`;

  constructor(private http: HttpClient) {}

  getSummary(filters: PatchQueryFilters): Observable<PatchingSummaryResponse> {
    return this.http.get<PatchingSummaryResponse>(`${this.baseUrl}/summary`, { params: this.toParams(filters) });
  }

  getDetails(filters: PatchQueryFilters): Observable<PatchingDetailsResponse> {
    return this.http.get<PatchingDetailsResponse>(`${this.baseUrl}/details`, { params: this.toParams(filters) });
  }

  getHistory(filters: PatchQueryFilters): Observable<PatchingHistoryResponse> {
    return this.http.get<PatchingHistoryResponse>(`${this.baseUrl}/history`, { params: this.toParams(filters) });
  }

  getFilterOptions(): Observable<FilterOptions> {
    return this.http.get<FilterOptions>(`${this.baseUrl}/filters`);
  }

  private toParams(filters: PatchQueryFilters): Record<string, string> {
    return Object.fromEntries(Object.entries(filters).filter(([, v]) => !!v)) as Record<string, string>;
  }
}
